import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { deleteHtmlTagsFromString, parseTextareaAnswer, getCharByElementPosition } from '../../../lib/exercise';

import Textarea from '../../textarea';
import ChoiceChip from '../../choice-chip';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';
import Spacer from '../../spacer';

const Label = styled.span`
    display: inline-block;
    font-weight: 600;
    margin-right: 4px;
`;

const Feedback = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
`;

export const CorrectChoiceChip = styled.span`
    margin-top: 8px;
`;

const getLabel = (missedAnswer, correct) => {
    if (missedAnswer) {
        return 'Risposta non data.';
    }

    return correct ? 'Risposta corretta.' : 'Risposta sbagliata.';
};

export const SingleFillBlankFeedback = ({ id, correct, correctAnswer, feedback, index, missedAnswer, text }) => {
    return (
        <div>
            <FluidContainer marginRight="regular">
                <Textarea
                    badgeIndex={getCharByElementPosition(index + 1)}
                    id={id}
                    isValidated={true}
                    validationType={missedAnswer ? 'missing' : correct ? 'success' : 'error'}
                    value={text ? text : correctAnswer}
                    parse={false}
                />
            </FluidContainer>
            <FluidContainer flexDirection="column" marginLeft="regular" marginRight="regular">
                <div>
                    <Label>{getLabel(missedAnswer, correct)}</Label>
                    {feedback && (
                        <Feedback>
                            <MathContent style={{ display: 'inline' }}>{feedback}</MathContent>
                        </Feedback>
                    )}
                </div>

                {!correct && !missedAnswer && (
                    <FluidContainer flexDirection="column" marginTop="small">
                        <Label>{'La risposta esatta è:'}</Label>
                        <CorrectChoiceChip>
                            <ChoiceChip id={`${index}`} type="validated" value={correctAnswer} disabled={true} validationType="missing" />
                        </CorrectChoiceChip>
                    </FluidContainer>
                )}
            </FluidContainer>
        </div>
    );
};

SingleFillBlankFeedback.propTypes = {
    id: PropTypes.string,
    correct: PropTypes.bool,
    correctAnswer: PropTypes.string,
    feedback: PropTypes.string,
    index: PropTypes.number,
    missedAnswer: PropTypes.bool,
    text: PropTypes.string,
};

const FillBlanksFeedback = ({ exercise, answers }) => {
    const myAnswers = exercise.options.map((option) => {
        const answer = answers.find((item) => item.gapId === option.id);

        const parsedCorrectValues = option.values.map((value) => deleteHtmlTagsFromString(value).trim());

        if (!answer) {
            return {
                ...option,
                insertedValue: '',
                correctValue: option.values[0],
                missedAnswer: true,
                correct: false,
            };
        }

        const parsedAnswer = deleteHtmlTagsFromString(answer.value);

        return {
            ...option,
            correctValue: option.values[0],
            insertedValue: answer.value,
            correct: parsedCorrectValues.some((correctValue) => parseTextareaAnswer(parsedAnswer) === parseTextareaAnswer(correctValue)),
            missedAnswer: false,
        };
    });

    return (
        <FluidContainer flexDirection="column" marginTop={['mobile', 'mobile', 'desktop']} paddingBottom="mobile">
            {myAnswers.map(
                (option, index) =>
                    option && (
                        <div key={index}>
                            <SingleFillBlankFeedback
                                key={option.id}
                                id={option.id}
                                index={index}
                                missedAnswer={option.missedAnswer}
                                text={option.insertedValue}
                                correct={option.correct}
                                feedback={option.feedback}
                                correctAnswer={option.correctValue}
                            />
                            {index < myAnswers.length - 1 && <Spacer size="regular" />}
                        </div>
                    ),
            )}
        </FluidContainer>
    );
};

FillBlanksFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
};

export default FillBlanksFeedback;
